export const formatDisplayDateWithYear = (date: string) => {
	const dateObj = new Date(date);

	return dateObj.toLocaleString('en-US', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		timeZone: 'UTC',
	});
};
